import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useResourceCount } from '../../hooks/useResourceCount'

import PageHeader from '../../components/ui/pageHeader/PageHeader'
import PartnerList, {
  PartnerFilter,
} from '../../components/authenticated/partners/partnersList/PartnersList'
import PartnerInvite from '../../components/authenticated/partners/partnerInvite/PartnerInvite'

const Partners = () => {
  const { t } = useTranslation('partners')
  const [refreshTrigger, setRefreshTrigger] = useState(false)
  const [statusFilter, setStatusFilter] = useState<PartnerFilter>('ALL')
  const { count: partnersCount, refetch: refetchPartnersCount } =
    useResourceCount(
      '/api/v1/partners/count',
      statusFilter === 'ALL'
        ? {}
        : statusFilter === 'FAVORITES'
          ? { favorite: 'true' }
          : { status: statusFilter },
      refreshTrigger
    )

  return (
    <div>
      <PageHeader
        title={{
          eyebrow:
            partnersCount === null
              ? undefined
              : t('partners.header.eyebrow', {
                  savedPartners: partnersCount,
                }),
          h1: t('partners.header.title'),
        }}
        sub={t('partners.header.sub')}
      />
      <PartnerInvite
        onInviteSuccess={() => {
          setRefreshTrigger(previous => !previous)
          refetchPartnersCount()
        }}
      />
      <PartnerList
        refreshTrigger={refreshTrigger}
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        onPartnersChange={refetchPartnersCount}
      />
    </div>
  )
}

export default Partners
